<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <el-alert
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 12px"
      title="以闲鱼成交订单为主线：买家确认收货后生成待结算记录。货款在闲鱼侧收取，财务确认线下打款给货主后在此标记已结算。闲鱼拍下时商品即置为已售出；关联识香订单用于平台发货履约。"
    />

    <div class="filter-box">
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="结算状态">
          <el-select v-model="filters.status" placeholder="全部" clearable style="width: 120px">
            <el-option label="待结算" value="PENDING" />
            <el-option label="已结算" value="PAID" />
            <el-option label="已作废" value="CANCELLED" />
          </el-select>
        </el-form-item>
        <el-form-item label="闲鱼订单号">
          <el-input v-model.trim="filters.goofishOrderNo" placeholder="模糊" clearable style="width: 170px" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="识香订单号">
          <el-input v-model.trim="filters.orderNo" placeholder="模糊" clearable style="width: 170px" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="商品编号">
          <el-input v-model.trim="filters.productNo" placeholder="模糊" clearable style="width: 120px" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="鉴别号">
          <el-input v-model.trim="filters.inspectionNo" placeholder="前三段或完整鉴别号" clearable style="width: 170px" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="寄售用户">
          <el-input v-model.trim="filters.consignorKeyword" placeholder="昵称/会员号/姓名" clearable style="width: 150px" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column label="闲鱼订单号" min-width="168" align="center" fixed="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag type="warning" size="mini">{{ saleChannelLabel(scope.row) }}</el-tag>
          <div class="sub-text" style="margin-top: 4px">{{ displayGoofishOrderNo(scope.row.goofishOrderNo) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" label="识香订单号" min-width="168" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.orderNo || "—" }}</template>
      </el-table-column>
      <el-table-column prop="productNo" label="商品编号" width="130" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.productNo || "—" }}</template>
      </el-table-column>
      <el-table-column prop="inspectionSeq" label="鉴别号" width="130" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.inspectionSeq || "—" }}</template>
      </el-table-column>
      <el-table-column label="商品信息" min-width="200" align="left" class-name="cell-title-wrap">
        <template slot-scope="scope">
          <div class="product-info-cell">
            <div>{{ scope.row.productTitle || "—" }}</div>
            <div
              v-if="scope.row.productListingPrice != null && scope.row.productListingPrice !== ''"
              class="sub-text"
            >
              原价：{{ formatMoney(scope.row.productListingPrice) }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="收款信息" min-width="200" align="left">
        <template slot-scope="scope">
          <div v-if="Number(scope.row.receiptAuthStatus) === 1" class="receipt-cell">
            <div v-if="scope.row.receiptCardName">户名：{{ scope.row.receiptCardName }}</div>
            <div v-if="scope.row.receiptCardNo">卡号：{{ scope.row.receiptCardNo }}</div>
            <div v-if="scope.row.receiptBankCode" class="sub-text">联行号：{{ scope.row.receiptBankCode }}</div>
            <div v-if="scope.row.receiptTelNo" class="sub-text">手机：{{ scope.row.receiptTelNo }}</div>
          </div>
          <span v-else class="sub-text">未完成收款认证</span>
        </template>
      </el-table-column>
      <el-table-column label="寄售用户" min-width="120" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.consignorNickName || "—" }}</div>
          <div v-if="scope.row.consignorScentId" class="sub-text">{{ scope.row.consignorScentId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="闲鱼实付" width="92" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.orderAmount) }}</template>
      </el-table-column>
      <el-table-column label="结算金额" width="92" align="center">
        <template slot-scope="scope">{{ formatMoney(calcSettlementAmount(scope.row)) }}</template>
      </el-table-column>
      <el-table-column label="结算状态" width="88" align="center">
        <template slot-scope="scope">
          <el-tag :type="settlementTagType(scope.row.settlementStatus)" size="mini">
            {{ settlementStatusLabel(scope.row.settlementStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="物流" width="100" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.logisticsNo">
            <el-tag size="mini" type="success">已发货</el-tag>
            <div v-if="Number(scope.row.goofishShipSynced) === 1" class="sub-text">已回写闲鱼</div>
          </template>
          <template v-else-if="isManualAuctionSettlement(scope.row)">
            <span class="sub-text">—</span>
            <div class="sub-text">未走平台发货</div>
          </template>
          <el-tag v-else size="mini" type="info">待发货</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" width="158" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.payTime) }}</template>
      </el-table-column>
      <el-table-column label="结算时间" width="158" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.paidAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="230" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="openOrderDetail(scope.row)">订单详情</el-button>
          <el-button
            v-if="scope.row.settlementStatus === 'PENDING'"
            size="mini"
            type="primary"
            :loading="markingId === scope.row.settlementId"
            @click="openMarkPaid(scope.row)"
          >标记已结算</el-button>
          <el-button
            size="mini"
            type="danger"
            :loading="deletingId === scope.row.settlementId"
            @click="confirmDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page_box">
      <el-pagination
        @current-change="changePage"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal"
      />
    </div>

    <el-dialog title="标记已结算" :visible.sync="markDialogVisible" width="460px">
      <el-form label-width="96px" size="small">
        <el-form-item label="闲鱼订单号">
          <span>{{ displayGoofishOrderNo(markForm.goofishOrderNo) }}</span>
        </el-form-item>
        <el-form-item label="识香订单号">
          <span>{{ markForm.orderNo || "—" }}</span>
        </el-form-item>
        <el-form-item label="闲鱼实付">
          <span>{{ formatMoney(markForm.orderAmount) }}</span>
        </el-form-item>
        <el-form-item label="结算金额" required>
          <el-input
            v-model.trim="markForm.settlementAmount"
            placeholder="实际打款给货主的金额"
            style="width: 200px"
          >
            <template slot="prepend">¥</template>
          </el-input>
          <div class="form-hint">默认带出应付货主金额，可按实际打款修改</div>
        </el-form-item>
        <el-form-item label="寄售用户">
          <span>{{ markForm.consignorNickName || "—" }}</span>
        </el-form-item>
        <el-form-item label="操作人">
          <el-input v-model.trim="markForm.paidBy" placeholder="可选，如运营姓名" maxlength="64" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="markForm.note" type="textarea" :rows="3" maxlength="200" placeholder="可选" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="markDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="markingId != null" @click="submitMarkPaid">确认已打款</el-button>
      </span>
    </el-dialog>

    <el-dialog title="识香订单详情" :visible.sync="orderDetailVisible" width="720px">
      <div v-if="orderDetailLoading" v-loading="true" style="min-height: 120px" />
      <div v-else-if="orderDetail" class="order-detail-body">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="闲鱼订单号">{{ displayGoofishOrderNo(currentRow.goofishOrderNo) }}</el-descriptions-item>
          <el-descriptions-item label="识香订单号">{{ orderDetail.orderNo || "—" }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">{{ orderStatusLabel(orderDetail.status) }}</el-descriptions-item>
          <el-descriptions-item label="结算状态">
            <el-tag :type="settlementTagType(currentRow.settlementStatus)" size="mini">
              {{ settlementStatusLabel(currentRow.settlementStatus) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="商品标题" :span="2">{{ orderDetail.productTitle || currentRow.productTitle || "—" }}</el-descriptions-item>
          <el-descriptions-item label="支付金额">{{ formatMoney(orderDetail.totalAmount) }}</el-descriptions-item>
          <el-descriptions-item label="应付货主">{{ formatMoney(calcSettlementAmount(currentRow)) }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{ formatTime(orderDetail.payTime) }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ formatTime(orderDetail.createTime) }}</el-descriptions-item>
          <el-descriptions-item label="收货人">{{ currentRow.receiverName || "—" }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ currentRow.receiverPhone || "—" }}</el-descriptions-item>
          <el-descriptions-item label="收货地址" :span="2">{{ currentRow.receiverAddress || "—" }}</el-descriptions-item>
          <el-descriptions-item label="物流公司">{{ orderDetail.logisticsCompany || "—" }}</el-descriptions-item>
          <el-descriptions-item label="物流单号">{{ orderDetail.logisticsNo || "—" }}</el-descriptions-item>
          <el-descriptions-item label="闲鱼物流回写">
            {{ Number(currentRow.goofishShipSynced) === 1 ? "已回写" : "未回写" }}
          </el-descriptions-item>
          <el-descriptions-item label="寄售用户">
            {{ currentRow.consignorNickName || "—" }}
            <span v-if="currentRow.consignorScentId">（{{ currentRow.consignorScentId }}）</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-else class="empty-tip">暂无关联识香订单信息</div>
      <span slot="footer">
        <el-button @click="orderDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  name: "GoofishOrderSettlementList",
  data() {
    return {
      historyArr: ["订单管理", "闲鱼订单结算"],
      loading: false,
      tableData: [],
      tableTotal: 0,
      currentPage: 1,
      pageSize: 20,
      filters: {
        status: "",
        goofishOrderNo: "",
        orderNo: "",
        productNo: "",
        inspectionNo: "",
        consignorKeyword: "",
      },
      markDialogVisible: false,
      markingId: null,
      deletingId: null,
      markForm: {
        settlementId: null,
        goofishOrderNo: "",
        orderNo: "",
        orderAmount: null,
        settlementAmount: "",
        consignorNickName: "",
        paidBy: "",
        note: "",
      },
      orderDetailVisible: false,
      orderDetailLoading: false,
      orderDetail: null,
      currentRow: {},
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    /** 无真实闲鱼单号（空 / 手工占位 AUCTION-P*）展示为 — */
    displayGoofishOrderNo(v) {
      const no = String(v || "").trim();
      if (!no || /^AUCTION-P\d+$/i.test(no)) return "—";
      return no;
    },
    saleChannelLabel(row) {
      const label = String((row && row.saleChannelLabel) || "").trim();
      if (label) return label;
      const auction = row && (row.auction === true || this.isManualAuctionSettlement(row));
      return auction ? "闲鱼拍卖" : "闲鱼";
    },
    /** 手工拍卖登记（无真实闲鱼履约发货链路） */
    isManualAuctionSettlement(row) {
      const no = String((row && row.goofishOrderNo) || "").trim();
      return !no || /^AUCTION-P\d+$/i.test(no);
    },
    formatMoney(v) {
      if (v == null || v === "") return "—";
      const n = Number(v);
      return Number.isFinite(n) ? n.toFixed(2) : String(v);
    },
    /** 结算金额：拍卖=台账或实付×0.93；普通闲鱼=商品原价×0.95（扣平台5%手续费） */
    calcSettlementAmount(row) {
      if (!row) return null;
      const auction = row.auction === true || this.isManualAuctionSettlement(row);
      if (auction) {
        if (row.settlementAmount != null && row.settlementAmount !== "") {
          return row.settlementAmount;
        }
        const paid = Number(row.orderAmount);
        if (!Number.isFinite(paid)) return null;
        return Number((paid * 0.93).toFixed(2));
      }
      if (row.settlementAmount != null && row.settlementAmount !== "") {
        return row.settlementAmount;
      }
      if (row.productListingPrice != null && row.productListingPrice !== "") {
        const listingPrice = Number(row.productListingPrice);
        if (!Number.isFinite(listingPrice)) return null;
        return Number((listingPrice * 0.95).toFixed(2));
      }
      return null;
    },
    formatTime(t) {
      if (!t) return "—";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },
    orderStatusLabel(v) {
      const m = {
        0: "待支付",
        1: "待发货",
        2: "待收货",
        3: "待评价",
        4: "已完成",
        5: "已退款",
        6: "已取消",
        7: "退款中",
      };
      const x = Number(v);
      return m[x] != null ? m[x] : String(v == null ? "—" : v);
    },
    settlementStatusLabel(status) {
      if (status === "PAID") return "已结算";
      if (status === "CANCELLED") return "已作废";
      return "待结算";
    },
    settlementTagType(status) {
      if (status === "PAID") return "success";
      if (status === "CANCELLED") return "info";
      return "warning";
    },
    buildQuery(page) {
      const payload = { page: page || 1, size: this.pageSize };
      if (this.filters.status) payload.status = this.filters.status;
      if (this.filters.goofishOrderNo) payload.goofishOrderNo = this.filters.goofishOrderNo;
      if (this.filters.orderNo) payload.orderNo = this.filters.orderNo;
      if (this.filters.productNo) payload.productNo = this.filters.productNo;
      if (this.filters.inspectionNo) payload.inspectionNo = this.filters.inspectionNo;
      if (this.filters.consignorKeyword) payload.consignorKeyword = this.filters.consignorKeyword;
      return payload;
    },
    fetchList(page) {
      this.loading = true;
      this.$https(this.$api.api.goofishSettlementList, this.buildQuery(page), "GET")
        .then((res) => {
          if (res.data && res.data.code == 200 && res.data.data) {
            this.tableData = res.data.data.records || [];
            this.tableTotal = res.data.data.total || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      this.currentPage = 1;
      this.fetchList(1);
    },
    resetFilters() {
      this.filters = {
        status: "",
        goofishOrderNo: "",
        orderNo: "",
        productNo: "",
        inspectionNo: "",
        consignorKeyword: "",
      };
      this.currentPage = 1;
      this.fetchList(1);
    },
    changePage(p) {
      this.currentPage = p;
      this.fetchList(p);
    },
    confirmDelete(row) {
      if (!row || !row.settlementId) return;
      const orderLabel = this.displayGoofishOrderNo(row.goofishOrderNo);
      this.$confirm(`确认删除该结算记录？闲鱼单号：${orderLabel}`, "提示", {
        type: "warning",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      })
        .then(() => this.submitDelete(row.settlementId))
        .catch(() => {});
    },
    submitDelete(settlementId) {
      this.deletingId = settlementId;
      this.$https(this.$api.api.goofishSettlementDelete, { id: settlementId }, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "已删除");
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "删除失败");
          }
        })
        .finally(() => {
          this.deletingId = null;
        });
    },
    openMarkPaid(row) {
      const amount = this.calcSettlementAmount(row);
      this.markForm = {
        settlementId: row.settlementId,
        goofishOrderNo: row.goofishOrderNo,
        orderNo: row.orderNo,
        orderAmount: row.orderAmount,
        settlementAmount: amount != null && amount !== "" ? String(amount) : "",
        consignorNickName: row.consignorNickName,
        paidBy: "",
        note: row.settlementNote || "",
      };
      this.markDialogVisible = true;
    },
    submitMarkPaid() {
      if (!this.markForm.settlementId) return;
      const amountStr = String(this.markForm.settlementAmount || "").trim();
      if (!amountStr) {
        this.$message.error("请填写结算金额");
        return;
      }
      const amount = Number(amountStr);
      if (!Number.isFinite(amount) || amount <= 0) {
        this.$message.error("结算金额无效");
        return;
      }
      this.markingId = this.markForm.settlementId;
      this.$https(
        this.$api.api.goofishSettlementMarkPaid,
        {
          id: this.markForm.settlementId,
          settlementAmount: Number(amount.toFixed(2)),
          paidBy: this.markForm.paidBy || undefined,
          note: this.markForm.note || undefined,
        },
        "POST"
      )
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.$message.success((res.data && res.data.msg) || "已标记");
            this.markDialogVisible = false;
            this.fetchList(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "操作失败");
          }
        })
        .finally(() => {
          this.markingId = null;
        });
    },
    openOrderDetail(row) {
      this.currentRow = row || {};
      this.orderDetail = null;
      this.orderDetailVisible = true;
      if (!row || !row.secondhandOrderId) {
        return;
      }
      this.orderDetailLoading = true;
      this.$https(this.$api.api.getSecondhandOrderById, { id: row.secondhandOrderId }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.orderDetail = res.data.data || null;
          } else {
            this.$message.error((res.data && res.data.msg) || "加载订单失败");
          }
        })
        .finally(() => {
          this.orderDetailLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="less">
.filter-box {
  margin: 12px 0;
  padding: 12px 12px 0;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.page_box {
  margin-top: 16px;
  text-align: right;
}
.sub-text {
  font-size: 12px;
  color: #909399;
  line-height: 1.3;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 24px 0;
}
.form-hint {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}
.receipt-cell {
  font-size: 13px;
  color: #303133;
  line-height: 1.5;
  word-break: break-all;
}
.product-info-cell {
  line-height: 1.5;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/pages/goofish/settlement/index.vue